import { POST_FEELINGS } from '@wlb/shared/constants';
import type { TranslateFn } from '@wlb/shared/types/common';

/**
 * Formats the API feeling key consistently wherever a post snapshot is shown.
 * Unknown legacy values stay visible instead of being dropped.
 */
export const formatPostFeeling = (
  feeling: string | null | undefined,
  t: TranslateFn,
): string | null => {
  if (!feeling) return null;

  const match = POST_FEELINGS.find(item => item.key === feeling);
  return match
    ? `${match.emoji} ${t(`home.createPost.feeling.${match.key}`)}`
    : feeling;
};
